import { Box, Text } from '@chakra-ui/react';
import { format, parse } from 'date-fns';
import { addOneHourToTime } from './helpers';

const PopupTitle = ({ time }: { time: any }) => {
    const { parsedTime, parsedDate } = time;
    const realStart = format(parse(parsedTime, 'h:mm:ss a', new Date()), 'h a');

    const realEnd = addOneHourToTime(parsedTime);

    return (
        <Box textAlign="center" mb="20px">
            <Text fontSize="14px" fontWeight={500} color={'gray.500'} mb="6px">
                {parsedDate}
            </Text>
            <Text fontSize="20px">{`${realStart} - ${realEnd}`}</Text>
        </Box>
    );
};

export default PopupTitle;
